var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodeBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.736,
    height: 34.949,
    viewBox: "0 0 36.736 34.949",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_001-ok",
    "data-name": "001-ok",
    transform: "translate(0 -12.438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    "data-name": "Path 982",
    d: "M3.017,0A3.017,3.017,0,0,1,6.034,3.017,3.154,3.154,0,0,1,4.54,5.622a2.722,2.722,0,0,1-1.523.412A3.017,3.017,0,0,1,3.017,0Z",
    transform: "translate(11.06 26.896)",
    fill: "#e3cb7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_980",
    "data-name": "Path 980",
    d: "M36.736,29.913,32.578,25.3l.651-6.181-6.081-1.287-3.1-5.389-5.677,2.537-5.677-2.537-3.1,5.389L3.508,19.114,4.159,25.3,0,29.913,4.159,34.53l-.651,6.181L9.589,42l3.1,5.389,5.677-2.537,5.677,2.537L27.148,42l6.081-1.287-.651-6.181Zm-17.487,0a5.172,5.172,0,1,1-5.172-5.172,5.178,5.178,0,0,1,5.172,5.172Zm1.578,5.172V24.741h2.155v2.776L26.1,24.654l1.458,1.587-3.817,3.508L27.7,33.574l-1.5,1.551-3.225-3.111v3.071Z",
    transform: "translate(0)",
    fill: "rgba(212,175,55,0.65)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeBox);
export default __webpack_public_path__ + "static/media/codeBox.48ff1ac564a78aed4d432801dcb20315.svg";
export { ForwardRef as ReactComponent };